export const publicVersion = "edge-rust-32-gc22bf115-2026-06-09T15-15-20Z";